<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs8>
        <h1 class="text-xs-left ma-3">Группы пользователей</h1>
      </v-flex>
    </v-layout>

    <div v-if="userGroupList.length > 0">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="userGroupList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.title }}</td>
                <td class="text-xs-left">
                  <div class="my-3">
                    <div
                        v-for="(access, index) in props.item.access_list"
                        :key="index"

                    >
                      {{ access.title }}
                    </div>
                  </div>
                </td>
                <td class="text-xs-left">
                  <v-btn
                      flat
                      icon
                      class="ma-1"
                      @click="editUserGroup(props.item.id)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                      flat
                      icon
                      class="ma-1"
                      @click="deleteUserGroup(props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить группу?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteUserGroupConfirm(deleteUserGroupId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteUserGroupCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Группы пользователей'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Список прав',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          userGroupList: false
        },
        deleteDialog: false,
        deleteUserGroupId: null
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.userGroupList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      editUserGroup (id) {
        this.$router.push('/users/group/edit/' + id)
      },
      deleteUserGroup (id) {
        this.deleteDialog = true
        this.deleteUserGroupId = id
      },
      deleteUserGroupCancel () {
        this.deleteDialog = false
        this.deleteUserGroupId = null
      },
      deleteUserGroupConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteUserGroup', {id: this.deleteUserGroupId})
          .then((data) => {
            this.$store.dispatch('getUserGroupList')
          })
          .catch((e) => {
            console.log(e)
          })
        this.deleteUserGroupId = null
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', 'Группы пользователей')
        this.$store.dispatch('getUserGroupList')
          .then(() => {
            this.pageDataReady.userGroupList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      userGroupList () {
        return this.$store.getters.userGroupList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserGroupList.vue